import { type DateObject } from "components/RangeCalendar";
import { generateDateObjects } from "components/RangeCalendar/helpers";

export function getLastNDays(n: number, startingDate?: DateObject): { startDate: DateObject | null, endDate: DateObject | null} {

    if(n == -1) {
        return {startDate: null, endDate: null}
    }

    let startingPoint = startingDate ? new Date(startingDate.year, startingDate.month - 1, startingDate.day) : new Date(); // Get the current date
    startingPoint.setDate(startingPoint.getDate() + 1);

    let endDate = {
        year: startingPoint.getFullYear(),
        month: startingPoint.getMonth() + 1, // In JavaScript, months are 0-based.
        day: startingPoint.getDate()
    };
    

    // N days ago.
    let startDateObj = startingPoint;
    startDateObj.setDate(startingPoint.getDate() - n);
    let startDate = {
        year: startDateObj.getFullYear(),
        month: startDateObj.getMonth() + 1, // In JavaScript, months are 0-based.
        day: startDateObj.getDate()
    };

    return { endDate, startDate};
}

export function getLastWeek(){

    let end = new Date();
    end.setDate(end.getDate() - end.getDay());
    let endObj = {year: end.getFullYear(), month: end.getMonth() + 1, day: end.getDate()}

    return getLastNDays(7, endObj)
}

export function getLastMonth(){
    let startDate = {year: new Date().getFullYear(), month: new Date().getMonth(), day: 1}
    let endDateObj = new Date();
    endDateObj.setDate(endDateObj.getDate() - endDateObj.getDay())

    let endDate = {year: new Date().getFullYear(), month: new Date().getMonth() + 1, day: 1}

    return {startDate, endDate}
}

export function getLastYear(){
    let startDate = {year: new Date().getFullYear() - 1, month: 1, day: 1}
    let endDate = {year: new Date().getFullYear(), month: 1, day: 1}

    return {startDate, endDate}
}

export function prettyDate(dateObj: DateObject) {
    if (dateObj) {
        return new Date(dateObj?.year, dateObj?.month-1, dateObj.day).toLocaleDateString('en-GB', {
                day: 'numeric',
                month: 'short',
        })
    }
}